import {Component, HostListener, OnDestroy, OnInit, signal} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {CookieService} from 'ngx-cookie-service';
import {VolumesService} from 'src/app/course/services/volumes.service';
import _ from 'underscore';
import { AboutCourseModalComponent } from '../about-course-modal/about-course-modal.component';
import { DiscoverCourse } from '../../components/discover-courses/discover-course-model';
import PageHelper from '../helpers/page.helper';
import {StartAssessmentModalComponent} from '../start-assessment-modal/start-assessment-modal.component';
import {CoursesService} from '../../courses.service';
import {AuthContextService} from 'src/app/services/auth-context.service';
import {ColorSchemeService} from 'src/app/services/color-scheme.service';
import {orderBy} from 'natural-orderby';
import {CheckoutModalService} from 'src/app/course/services/checkout-modal.service';
import {MetaService} from 'src/app/services/meta.service';

@Component({
  selector: 'app-learn-to-fly',
  templateUrl: './learn-to-fly.component.html',
  styleUrls: ['./learn-to-fly.component.scss']
})
export class LearnToFlyComponent implements OnInit, OnDestroy {
  course: any;
  courses: any;
  videos: any[] = [];
  volume: any;
  popularCourses: DiscoverCourse[] = [];
  showGoTopArrow = false;
  user: any;
  isLearnToFlyCoursePaid = signal(false);

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public volumesService: VolumesService,
    public bsModalRef: BsModalRef,
    public colorSchemeService: ColorSchemeService,
    private cookieService: CookieService,
    private modalService: BsModalService,
    private coursesService: CoursesService,
    private authContextService: AuthContextService,
    private checkoutModalService: CheckoutModalService,
    private metaService: MetaService
  ) {
  }

  ngOnInit(): void {
    this.metaService.addMetaTags('learnToFly');

    this.user = this.authContextService.user;
    this.courses = this.route.snapshot.data.courses;
    this.coursesService.load().subscribe((courses) => {
      this.course = courses.allCourseTypes['PRIVATE'];
      this.isLearnToFlyCoursePaid.set(
        this.authContextService.isCoursePurchasedByUser(this.course?.webAppId)
      );

      this.volumesService.load('PRIVATE').subscribe(async (resp) => {
        let i = 0;
        const volumes = this.volumesService.filter(resp, 'VIDEO_TRAINING');

        this.volume = await this.volumesService.loadVolume('PRIVATE', volumes[0].uuid);

        this.volumesService.getElementsFromVolume('PRIVATE', volumes[0].uuid).subscribe(elements => {
          elements['videos'] = orderBy(
            elements['videos'] as Array<any>,
            [v => v['sectionId']],
            ['asc']
          );

          while (this.videos.length < 8) {
            this.videos.push(elements.videos[i]);
            i++;
          }
        });
      });
    });

    this.populatePopularCourses();
    document.getElementsByTagName('body')[0].style.overflowX = 'hidden';
  }

  ngOnDestroy(): void {
    this.metaService.removeMetaTags();
  }

  openAboutThisCourseModal() {
    const initialState = {
      course: this.course
    };
    this.bsModalRef = this.modalService.show(AboutCourseModalComponent, {
      initialState,
      class: 'modal-lg rounded-modal',
      backdrop: 'static'
    });
  }

  openStartAssessmentModal() {
    const initialState = {};
    this.bsModalRef = this.modalService.show(StartAssessmentModalComponent, {
      initialState,
      class: 'modal-lg rounded-modal',
      backdrop: 'static'
    });
  }

  goToTestPrep() {
    this.cookieService.set('autoOpenCreateAccountModal', 'true');
    this.router.navigate(['course/PRIVATE/testprep']);
  }

  populatePopularCourses() {
    const instrumentCourse = this.courses?.allCourseTypes['INSTRUMENT'];
    const commercialCourse = this.courses?.allCourseTypes['COMMERCIAL'];
    const tailwheelCourse = this.courses?.allCourseTypes['TAILWHEEL'];
    const g1000Course = this.courses?.allCourseTypes['G1000'];

    this.popularCourses.push(this.mapCourse(instrumentCourse));
    this.popularCourses.push(this.mapCourse(commercialCourse));
    this.popularCourses.push(this.mapCourse(tailwheelCourse));
    this.popularCourses.push(this.mapCourse(g1000Course));
  }

  goToTopOfPage() {
    PageHelper.topFunction();
  }

  @HostListener('window:scroll', ['$event']) // for window scroll events
  onScroll(event) {
    if (window.pageYOffset === 0) {
      this.showGoTopArrow = false;
    } else {
      this.showGoTopArrow = true;
    }
  }

  onBuyClick(event) {
    event.preventDefault();
    event.stopPropagation();

    this.checkoutModalService.buyCourse(this.course);
  }

  private mapCourse(course): DiscoverCourse {
    let previewLink = `course/${course.webAppId}/volumes`;

    if (
      course.inCoursePurchaseEnabled &&
      (course.webAppId === 'PRIVATE' ||
        course.webAppId === 'SPORT' ||
        course.webAppId === 'INSTRUMENT')
    ) {
      previewLink = `${previewLink}/VIDEO_TRAINING`;
    }

    return {
      title: course.longName,
      thumbnail_url: course.thumbnailUrl,
      difficulty: course.difficulty,
      price: course.price,
      previewLink,
      purchaseLink: course.webPurchaseUrl,
      isLocked: true,
      purchased: this.user ? !!this.user.coursePermissions[course.webAppId] : false,
      courseType: course.webAppId,
      requireRegistrationForPreview: course.requireRegistrationForPreview,
      buyLinkText: course.buyLinkText,
      inCoursePurchaseEnabled: course.inCoursePurchaseEnabled,
      shoppingCartImageUrl: course.shoppingCartImageUrl,
      deepLinkToMarketing: course.deepLinkToMarketing,
    };
  }
}
